var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98.908mm",
    height: "92.896mm",
    viewBox: "0 0 98.908 92.896",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99994 0 0 1.0661 -14.572 -19.192)",
    fill: "#fff",
    stroke: "#9e00cb"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 14.66,
    y: -32.398,
    width: 98.739,
    height: 14.308,
    rx: 4.1358,
    ry: 4.3033,
    strokeWidth: 0.17514
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 14.66,
    y: -68.724,
    width: 98.739,
    height: 14.308,
    rx: 4.1358,
    ry: 4.3033,
    strokeWidth: 0.17514
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(1,-1)",
    x: 14.66,
    y: -105.05,
    width: 98.739,
    height: 14.308,
    rx: 4.1358,
    ry: 4.3033,
    strokeWidth: 0.17514
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgMenu);
export default __webpack_public_path__ + "static/media/burg-menu.427868ddb8d62b8a9b077b899242853f.svg";
export { ForwardRef as ReactComponent };